import {
  RugbyLeagueEventStatusId,
  RugbyLeagueIncidentId,
} from '@collector/sportsapi-client-legacy'

import {
  EventRelatedStatusConfig,
  FINISHED_DESCRIPTION,
  WAITING_FOR_EXTRATIME_DESCRIPTION,
  WAITING_FOR_PENALTY_DESCRIPTION,
} from '../../../configuration'

const otherStatusIncidents: RugbyLeagueIncidentId[] = [
  RugbyLeagueIncidentId.NotStarted,
  RugbyLeagueIncidentId.FinishedAwardedWin,
  RugbyLeagueIncidentId.Interrupted,
  RugbyLeagueIncidentId.Postponed,
  RugbyLeagueIncidentId.Abandoned,
  RugbyLeagueIncidentId.Cancelled,
  RugbyLeagueIncidentId.ToFinish,
]

export const eventRelatedStatusConfig: EventRelatedStatusConfig<
  RugbyLeagueEventStatusId,
  RugbyLeagueIncidentId
> = {
  [RugbyLeagueEventStatusId.NotStarted]: {
    possibleNextStatusIncidents: [
      RugbyLeagueIncidentId.FirstHalf,
      RugbyLeagueIncidentId.StartDelayed,
    ],
    otherStatusIncidents: otherStatusIncidents.filter(
      (incidentId) => incidentId !== RugbyLeagueIncidentId.NotStarted,
    ),
  },
  [RugbyLeagueEventStatusId.FirstHalf]: {
    possibleNextStatusIncidents: [RugbyLeagueIncidentId.Halftime],
    otherStatusIncidents,
  },
  [RugbyLeagueEventStatusId.Halftime]: {
    possibleNextStatusIncidents: [RugbyLeagueIncidentId.SecondHalf],
    otherStatusIncidents,
  },
  [RugbyLeagueEventStatusId.SecondHalf]: {
    possibleNextStatusIncidents: [
      {
        incidentId: RugbyLeagueIncidentId.FinishedRegularTime,
        description: FINISHED_DESCRIPTION,
      },
      {
        incidentId: RugbyLeagueIncidentId.WaitingForExtratime,
        description: WAITING_FOR_EXTRATIME_DESCRIPTION,
      },
      {
        incidentId: RugbyLeagueIncidentId.WaitingForPenalty,
        description: WAITING_FOR_PENALTY_DESCRIPTION,
      },
    ],
    otherStatusIncidents,
  },
  [RugbyLeagueEventStatusId.WaitingForExtratime]: {
    possibleNextStatusIncidents: [RugbyLeagueIncidentId.ExtratimeFirstHalf],
    otherStatusIncidents,
  },
  [RugbyLeagueEventStatusId.ExtratimeFirstHalf]: {
    possibleNextStatusIncidents: [RugbyLeagueIncidentId.ExtratimeHalftime],
    otherStatusIncidents,
  },
  [RugbyLeagueEventStatusId.ExtratimeHalftime]: {
    possibleNextStatusIncidents: [RugbyLeagueIncidentId.ExtratimeSecondHalf],
    otherStatusIncidents,
  },
  [RugbyLeagueEventStatusId.ExtratimeSecondHalf]: {
    possibleNextStatusIncidents: [
      {
        incidentId: RugbyLeagueIncidentId.WaitingForPenalty,
        description: WAITING_FOR_PENALTY_DESCRIPTION,
      },
      RugbyLeagueIncidentId.FinishedAfterExtratime,
    ],
    otherStatusIncidents,
  },
  [RugbyLeagueEventStatusId.WaitingForPenalty]: {
    possibleNextStatusIncidents: [RugbyLeagueIncidentId.PenaltiesStarted],
    otherStatusIncidents,
  },
  [RugbyLeagueEventStatusId.Penalties]: {
    possibleNextStatusIncidents: [RugbyLeagueIncidentId.FinishedAfterPenalties],
    otherStatusIncidents,
  },
  [RugbyLeagueEventStatusId.FinishedRegularTime]: {
    possibleNextStatusIncidents: [],
    otherStatusIncidents,
  },
  [RugbyLeagueEventStatusId.FinishedAfterExtratime]: {
    possibleNextStatusIncidents: [],
    otherStatusIncidents,
  },
  [RugbyLeagueEventStatusId.Interrupted]: {
    possibleNextStatusIncidents: [],
    otherStatusIncidents: otherStatusIncidents.filter(
      (incidentId) => incidentId !== RugbyLeagueIncidentId.Interrupted,
    ),
  },
  [RugbyLeagueEventStatusId.Postponed]: {
    possibleNextStatusIncidents: [],
    otherStatusIncidents: otherStatusIncidents.filter(
      (incidentId) => incidentId !== RugbyLeagueIncidentId.Postponed,
    ),
  },
  [RugbyLeagueEventStatusId.Abandoned]: {
    possibleNextStatusIncidents: [],
    otherStatusIncidents: otherStatusIncidents.filter(
      (incidentId) => incidentId !== RugbyLeagueIncidentId.Abandoned,
    ),
  },
  [RugbyLeagueEventStatusId.Cancelled]: {
    possibleNextStatusIncidents: [],
    otherStatusIncidents: otherStatusIncidents.filter(
      (incidentId) => incidentId !== RugbyLeagueIncidentId.Cancelled,
    ),
  },
  [RugbyLeagueEventStatusId.ToFinish]: {
    possibleNextStatusIncidents: [],
    otherStatusIncidents: otherStatusIncidents.filter(
      (incidentId) => incidentId !== RugbyLeagueIncidentId.ToFinish,
    ),
  },
}
